import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function TestTypeEdit() {
  const { id } = useParams();
  const [name, setName] = useState("");
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  // Tür bilgisi getir
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/test-types/test-types/${id}`
        );
        setName(data.name || "");
        setMinAge(data.min_age || "");
        setMaxAge(data.max_age || "");
      } catch (err) {
        console.error("Tür bilgisi alınamadı:", err);
        toast.error("Tür bilgisi alınamadı");
      }
    })();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      return toast.error("Başlık zorunlu!");
    }

    setLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/api/test-types/${id}`,
        {
          name: name.trim(),
          min_age: minAge || null,
          max_age: maxAge || null,
        }
      );

      toast.success("Test türü başarıyla güncellendi!");
      setTimeout(() => {
        nav("/test-types/table");
      }, 1000);
    } catch (err) {
      console.error("❌ Güncelleme hatası:", err);
      toast.error("Güncelleme sırasında bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="p-4">
      <ToastContainer />
      <div className="card p-4">
        <h5 className="mb-3 fw-bold">Test Türü Düzenle</h5>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label">Başlık</label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              disabled={loading}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Minimum Yaş</label>
            <input
              type="number"
              className="form-control"
              value={minAge}
              onChange={(e) => setMinAge(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Maksimum Yaş</label>
            <input
              type="number"
              className="form-control"
              value={maxAge}
              onChange={(e) => setMaxAge(e.target.value)}
              disabled={loading}
            />
          </div>
          <div className="d-flex justify-content-center">
            <button
              type="submit"
              className="btn btn-primary px-4"
              disabled={loading}
            >
              {loading ? "Kaydediliyor..." : "Kaydet"}
            </button>
          </div>
        </form>
      </div>
    </section>
  );
}
